import AmexAppDownload from './AmexAppDownload';

export default AmexAppDownload;
